<template>
  <div
    class="button is-rounded"
    :class="[
      css,
      { [cssActive ? cssActive : 'is-success']: active },
      { [cssInactive ? cssInactive : '']: !active }
    ]"
    @click="$emit('click', $event)"
  >
    <span v-if="active" class="icon">
      <i :class="[icon]"></i>
    </span>
    <span>
      <slot></slot>
    </span>
  </div>
</template>

<script>
export default {
  components: {},
  props: ["name", "active", "icon", "css", "cssInactive", "cssActive"],
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>
